const addDays = (dateString: string, days: number): Date => {
	const dateObject = new Date(dateString.replace(/-/g, '/').replace('T', ' '))
	const newDate = new Date(dateObject.getTime() + days * 24 * 60 * 60 * 1000)
	return newDate
}

export { addDays }
